/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Badge_Disabled_PeriodInputs */



/**
* | output |
* | --- |
* | "Disabled this period" |
*
* @param {Sub_Addons_Badge_Disabled_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_badge_disabled_period = /** @type {((inputs?: Sub_Addons_Badge_Disabled_PeriodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Badge_Disabled_PeriodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In dieser Periode deaktiviert")
	return /** @type {LocalizedString} */ ("Disabled this period")
});